import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
  DefaultTitleMediumFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const AboutUsSectionContainer = styled.section(({ theme }) => ({
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const AboutUsSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
  },
}));

export const AboutUsSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const AboutUsStepList = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const AboutUsStepItem = styled.div(({ theme, $isLastSteps }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "25px",

  position: "relative",
  paddingLeft: "40px",
  paddingBottom: "20px",
  minHeight: "96px",
  marginLeft: "20px",
  borderLeft: !$isLastSteps ? `1px solid ${theme.color.line.medium}` : "none",

  [theme.breakpoint.lg()]: {
    paddingLeft: "60px",
    paddingBottom: "60px",
    marginLeft: 0,
  },
}));

export const AboutUsStepItemCircle = styled.div(({ theme }) => ({
  position: "absolute",
  width: "34px",
  height: "34px",
  left: -17,
  top: 0,
  backgroundColor: theme.color.brandPrimary.light,
  borderRadius: "50%",
  border: `4px solid ${theme.color.neutral["08"]}`,

  "&.primary-dark": {
    backgroundColor: theme.color.brandPrimary.dark,
  },

  "&.secondary": {
    backgroundColor: theme.color.brandSecondary.light,
  },

  "&.primary-dark, &.secondary": {
    width: "40px",
    height: "40px",
    left: -20,
  },
}));

export const AboutUsStepItemTitle = styled.div(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
  lineHeight: "150%",

  [theme.breakpoint.lg()]: {
    lineHeight: "130%",
  },
}));

export const AboutUsStepItemContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    gap: "40px",
  },
}));

export const AboutUsStepItemImage = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "64px",
  width: "100%",

  [theme.breakpoint.lg()]: {
    maxWidth: "129px",
  },
}));

export const AboutUsStepItemDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),

  a: {
    color: theme.color.brandPrimary.light,
    textDecoration: "none",
  },

  "strong, a": {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: "600",
  },
}));
